import React from 'react';
import styles from './Footer.module.scss';
import FooterLogo from './FooterLogo';

import Location from '../../../assets/img/mobile-gps.svg';
import Phone from '../../../assets/img/mobile-phone.svg';
import Mail from '../../../assets/img/mobile-mail.svg';
import PinkSlash from '../../../assets/img/pink-slash.svg';

// import VkFix from '../../../assets/img/vk.png';
// import Tg from '../../../assets/img/tg.png';
import { ReactComponent as Icon_vk } from '../../../assets/img/icon_vk.svg';
import { ReactComponent as Icon_tlgrm } from '../../../assets/img/icon_telegram.svg';

import AgreementLink from '../../../assets/docs/Agreement.pdf';
import { Link } from 'react-router-dom';
import Container from '../../templates/Container';

const MobileFooter = () => {
  return (
    <footer className={styles.mobile_footer}>
      <Container>
        <div className={styles.footer_info}>
          <div className={styles.head_of_footer}>
            <FooterLogo />
            <p>Индустрия | Креативное пространство</p>
          </div>
          <div className={styles.middle_of_header}>
            <ul className={styles.contacts}>
              <li>
                <img src={Location} alt="location" />
                Красноярск, ул. 9 мая, 77, ТРЦ&nbsp;«Планета»
              </li>
              <li className={styles.contacts_item}>
                <img src={Phone} alt="phone" />
                <a href="tel:+79333210507">+7 (933) 321-05-07 </a>
              </li>
            </ul>
            <ul className={styles.contacts}>
              <li className={styles.address}>
                <img src={Location} alt="location" />
                <address>Красноярск, ул. Ады Лебедевой, 93В</address>
              </li>
              <li className={styles.contacts_item + ' ' + styles.phone}>
                <img src={Phone} alt="phone" /> <a href="tel:+73912809500">+7 (391) 280-95-00</a>, <br />
                <a href="tel:+79130309500">+7 (913) 030-95-00</a>
              </li>
              <li className={styles.contacts_item}>
                <img src={Mail} className={styles.mailImage} alt="mail" />{' '}
                <a href="mailto:info@industry.art">info@industry.art</a>
              </li>
            </ul>
            <ul className={styles.docs}>
              <li>
                <img src={PinkSlash} alt="." />
                <a href={AgreementLink} download target="_blank" rel="noopener noreferrer">
                  Пользовательское соглашение
                </a>
              </li>
              <li>
                <img src={PinkSlash} alt="." />
                <Link to={'/gallery/payment_and_delivery'}>Доставка и оплата</Link>
              </li>
            </ul>
          </div>
          <div className={styles.bottom_of_footer}>
            <p>
              <span>ОГРН: </span>1222400007500
            </p>
            <p>
              <span>ИНН: </span>2466291084
            </p>
          </div>
          <div className={styles.socials}>
            <a href="https://t.me/industry_art" target="_blank" className={styles.social} rel="noreferrer">
              <Icon_tlgrm />
            </a>
            <a href="https://vk.com/industry_art" target="_blank" className={styles.social} rel="noreferrer">
              <Icon_vk />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default MobileFooter;
